export default "__VITE_ASSET__yk5hYokX__"